import React from 'react';
import createSvgIcon from '@mui/icons-material/utils/createSvgIcon';
import parseColor from '../util/parseColor';
import { styled } from '../styled';

const Icon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    fill='none'
    color='inherit'
  >
    <path
      d='M8 17.75C6.21667 17.3 4.77083 16.3542 3.6625 14.9125C2.55417 13.4708 2 11.8333 2 10C2 7.76667 2.775 5.875 4.325 4.325C5.875 2.775 7.76667 2 10 2C11.8333 2 13.4708 2.55417 14.9125 3.6625C16.3542 4.77083 17.3 6.21667 17.75 8H15.65C15.2167 6.8 14.4875 5.83333 13.4625 5.1C12.4375 4.36667 11.2833 4 10 4C8.33333 4 6.91667 4.58333 5.75 5.75C4.58333 6.91667 4 8.33333 4 10C4 11.2833 4.36667 12.4375 5.1 13.4625C5.83333 14.4875 6.8 15.2167 8 15.65V17.75ZM12 22C11.45 22 10.9792 21.8042 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20V12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10H20C20.55 10 21.0208 10.1958 21.4125 10.5875C21.8042 10.9792 22 11.45 22 12V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H12ZM12 20H20V12H12V20ZM12.5 19H19.5L17.2 16L15.5 18.25L14.3 16.6L12.5 19Z'
      fill='currentColor'
    />
  </svg>,
  'CreateMedia',
);

const ColoredIcon = styled(Icon)(({ theme, color }) => ({
  color: parseColor(theme, color),
}));

export default ColoredIcon;
